import { render, staticRenderFns } from "./votingsSlider.vue?vue&type=template&id=35e23525&"
import script from "./votingsSlider.vue?vue&type=script&lang=js&"
export * from "./votingsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports